import { isRouteErrorResponse, Navigate, useRouteError } from 'react-router'

/**
 * Sends routing errors to the suite error boundary.
 * Unmatched URLs follow the landing flow (Atlas ADR-0015) so typos are not reported as crashes.
 */
export const RethrowRouteError = () => {
  const error = useRouteError()

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <Navigate replace to="/" />
  }

  throw error
}
